import { Card, CardBody, CardSubtitle, CardTitle } from 'reactstrap';
import PropTypes from 'prop-types';
import React from "react";
import {Link} from "react-router-dom";

const ComponentCard = ({children, title, subtitle, buttonLabel, buttonLink, buttonOnClick}) => {
  return (
    <Card>
      <CardTitle>
        {title ? (
          <h4 className="card-header d-flex justify-content-between align-items-center">
            {title}
            {buttonLabel && buttonLink ? (
              <Link className="btn btn-primary btn-xs" to={buttonLink} title={buttonLabel}>
                {buttonLabel}
              </Link>
            ) : null}
            {buttonLabel && buttonOnClick ? (
              <Link className="btn btn-primary btn-xs" onClick={buttonOnClick} title={buttonLabel}>
                {buttonLabel}
              </Link>
            ) : null}
          </h4>
        ) : null}
      </CardTitle>
      <CardBody className="p-3">
        <CardSubtitle className="text-muted mb-3 display-none">{subtitle || ''}</CardSubtitle>
        <div>{children}</div>
      </CardBody>
    </Card>
  );
};

ComponentCard.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonLink: PropTypes.string,
    buttonOnClick: PropTypes.func,
    subtitle: PropTypes.node
};

export default ComponentCard;
